import { Button, Form, Stack, Text, TextInput } from 'shell/components';

const FormDemo = () => {
    return (
        <>
            <Text variant={'sh1'}>Form</Text>
            <Form onSubmit={(e) => console.log(`Your email is ${e.target.email.value}!`)}>
                <Stack alignItems={'flex-start'} spacing={2}>
                    <TextInput label={'Email'} name={'email'} required />
                    <Button>Submit</Button>
                </Stack>
            </Form>
        </>
    );
};

export default FormDemo;
